import React from "react";
import { Router } from "react-router-dom";
import { createBrowserHistory } from "history";
import UAParser from "ua-parser-js";

import routes from "./routes";
import { OnboardingPopup } from "components/OnboardingPopup";
import { ProvideAuth } from "hooks/useAuth";
import { useWindowFocus } from "hooks/useWindowFocus";
import "./App.scss";
import { logPageView } from "utils/analytics";

let routerHistory = createBrowserHistory();
routerHistory.listen(location => {
  logPageView(location.pathname);
});

const isDesktop = UAParser().device.type === undefined;

function App() {
  const focused = useWindowFocus();
  React.useEffect(() => {
    window.analytics.track(`app.${focused ? "opened" : "closed"}`);
    window.analytics.track("app.focus", { focused });
  }, [focused]);
  React.useEffect(() => {
    logPageView();
  }, []);
  if (isDesktop) {
    // return <h1>Please try again on mobile 📱😉</h1>
  }
  return (
    <ProvideAuth>
      <OnboardingPopup />
      <div className="App">
        <Router history={routerHistory}>{routes}</Router>
      </div>
    </ProvideAuth>
  );
}

export { App };
